import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sapConcur = defineConnector({
  identifier: "sapConcur",
  name: "SAP Concur",
  tagLine: "Travel and expense management",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://[^/]*\\.api\\.concursolutions\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Register an app in the SAP Concur Web Services admin",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your SAP Concur instance and navigate to **Administration > Company > Web Services**. Under ‘Register Partner Application’, create a new app. You’ll receive a Client ID and Client Secret. You’ll also need your Company UUID (found under **Administration > Company > Company Profile**) and a Company Request Token generated from the Web Services page.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Region",
          placeholder: "us",
          required: true,
          target: { kind: "configuration", field: "region" },
          helperText: "Your data center region: us, eu, or cn",
        },
        {
          kind: "input",
          label: "Company UUID",
          required: true,
          target: { kind: "configuration", field: "companyUUID" },
        },
        {
          kind: "input",
          label: "Company Request Token",
          required: true,
          target: { kind: "configuration", field: "companyRequestToken" },
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: (configuration) =>
      `https://${configuration.region}.api.concursolutions.com/oauth2/v0/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.region}.api.concursolutions.com/profile/v1/me`,
  },
  publicEnvVars: ({ region }) => ({
    SAP_CONCUR_REGION: region || "",
  }),
});
